/* ==========================================================================
   DIVA LONDON — Custom Brand JavaScript
   Custom cursor, page loader, petal injection, cookie banner, scroll reveal
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Page Loader ---------- */
  var loader = document.getElementById('diva-loader');
  if (loader) {
    if (sessionStorage.getItem('diva-loaded')) {
      loader.classList.add('is-hidden');
    } else {
      sessionStorage.setItem('diva-loaded', '1');
      window.addEventListener('load', function () {
        setTimeout(function () {
          loader.classList.add('is-hidden');
        }, 800);
      });
      // Failsafe: hide after 3 seconds regardless
      setTimeout(function () {
        loader.classList.add('is-hidden');
      }, 3000);
    }
  }

  /* ---------- Custom Cursor (Desktop) ---------- */
  var cursor = document.getElementById('diva-cursor');
  if (cursor && window.matchMedia('(hover: hover) and (min-width: 1025px)').matches) {
    var cx = 0, cy = 0;
    var tx = 0, ty = 0;

    document.addEventListener('mousemove', function (e) {
      tx = e.clientX;
      ty = e.clientY;
    });

    (function loop() {
      cx += (tx - cx) * 0.35;
      cy += (ty - cy) * 0.35;
      cursor.style.transform = 'translate(' + cx + 'px, ' + cy + 'px) translate(-50%, -50%)';
      requestAnimationFrame(loop);
    })();

    // Expand on interactive elements
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest('a, button, [role="button"], input, select, textarea, summary, label')) {
        cursor.classList.add('is-hovering');
      }
    });
    document.addEventListener('mouseout', function (e) {
      if (e.target.closest('a, button, [role="button"], input, select, textarea, summary, label')) {
        cursor.classList.remove('is-hovering');
      }
    });
  }

  /* ---------- Petal Injection ---------- */
  var petalContainer = document.getElementById('diva-petals');
  if (petalContainer) {
    var colors = ['rose', 'blush', 'gold', 'soft'];
    var total = window.innerWidth < 768 ? 6 : 12;

    for (var i = 0; i < total; i++) {
      var petal = document.createElement('div');
      petal.className = 'diva-petal diva-petal--' + colors[i % colors.length];
      petal.innerHTML = '<div class="diva-petal__shape"></div>';
      petalContainer.appendChild(petal);
    }
  }

  /* ---------- Cookie Banner ---------- */
  var cookieBanner = document.getElementById('diva-cookie');
  var cookieAccept = document.getElementById('diva-cookie-accept');

  if (cookieBanner && !localStorage.getItem('diva-cookies-accepted')) {
    setTimeout(function () {
      cookieBanner.classList.add('is-visible');
    }, 1500);
  }

  if (cookieAccept) {
    cookieAccept.addEventListener('click', function () {
      localStorage.setItem('diva-cookies-accepted', '1');
      cookieBanner.classList.remove('is-visible');
    });
  }

  /* ---------- Scroll Reveal (includes gold-line & text-reveal) ---------- */
  var revealSelectors = '.diva-reveal, .diva-gold-line, .diva-text-reveal';
  var reveals = document.querySelectorAll(revealSelectors);
  if (reveals.length > 0 && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    reveals.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ---------- Magnetic Buttons ---------- */
  if (window.matchMedia('(hover: hover) and (min-width: 1025px)').matches) {
    document.querySelectorAll('.diva-magnetic').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = 'translate(' + (x * 0.15) + 'px, ' + (y * 0.15) + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = 'translate(0, 0)';
      });
    });
  }

  /* ---------- Announcement Bar Dismiss ---------- */
  var announcementSection = document.querySelector('[id*="header_announcements"]') || document.querySelector('[id*="header-announcements"]');
  if (announcementSection) {
    // Check if already dismissed this session
    if (sessionStorage.getItem('diva-announcement-dismissed')) {
      announcementSection.classList.add('is-dismissed');
    } else {
      // Inject dismiss button into the announcement bar
      var announcementAside = announcementSection.querySelector('.announcement-bar') || announcementSection;
      var dismissBtn = document.createElement('button');
      dismissBtn.className = 'diva-announcement-dismiss';
      dismissBtn.setAttribute('aria-label', 'Dismiss announcement');
      dismissBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg>';
      announcementAside.appendChild(dismissBtn);

      dismissBtn.addEventListener('click', function () {
        sessionStorage.setItem('diva-announcement-dismissed', '1');
        announcementSection.classList.add('is-dismissed');
      });
    }
  }

  /* ---------- Header Scroll — Frosted cream state after 80px ---------- */
  var headerComp = document.querySelector('header-component');
  if (headerComp) {
    var onHeaderScroll = function () {
      if (window.scrollY > 80) {
        headerComp.classList.add('is-scrolled');
      } else {
        headerComp.classList.remove('is-scrolled');
      }
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll(); // run once on load
  }

  /* ---------- Hero Scroll Fade ---------- */
  var hero = document.querySelector('.hero');
  if (hero) {
    window.addEventListener('scroll', function () {
      var scrollY = window.pageYOffset;
      var heroHeight = hero.offsetHeight;
      var opacity = 1 - (scrollY / heroHeight);
      hero.style.opacity = Math.max(0, Math.min(1, opacity));
    }, { passive: true });
  }

  /* ---------- Cart Badge Bounce ---------- */
  var cartBubble = document.querySelector('.cart-count-bubble, [data-cart-count]');
  if (cartBubble && 'MutationObserver' in window) {
    new MutationObserver(function () {
      cartBubble.style.animation = 'none';
      cartBubble.offsetHeight; // trigger reflow
      cartBubble.style.animation = 'diva-bounce 0.5s ease';
    }).observe(cartBubble, { childList: true, characterData: true, subtree: true });
  }

})();
